<template>
  <b-container id="edu" class="pb-2" fluid>
    <h3>
      <b-row no-gutters align-v="center" cols="3">
        <b-col cols="1">
          <font-awesome-icon icon="apple-alt" size="xs" />
        </b-col>
        <b-col class="pt-1">
          <span>
            Education
          </span>
        </b-col>
      </b-row>
    </h3>
    <b-card-group deck>
      <b-card class="mt-4 ml-4 mb-4"  v-for="(w, k, i) in work" :key="i">
        <b-card-title title-tag='h5'>
          {{ w[0] }}
        </b-card-title>
        <b-card-sub-title> {{ w[2] }} </b-card-sub-title>
        <b-card-sub-title class="pt-2 font-italic text-muted">{{ w[1] }}</b-card-sub-title>
        <b-card-text class=" text-muted" v-for="i in w.slice(3)" :key="i">{{i}}</b-card-text>
      </b-card>
    </b-card-group>
  </b-container>
</template>
<script>
export default {
  components: {},
  data () {
    return {
      work: {
        masters: [
          'Masters of Science in Computer Science',
          '2019',
          'UT Tyler'
        ],
        under: [
          'Bachelor of Science in Mining Engineering',
          '2010',
          'Colorado School of Mines',
          'Minor in Petroleum Engineering'
        ]
      }
    }
  },
  computed: {},
  methods: {}
}
</script>

<style>
#about {
}

.head {
  padding-left: 10px;
}
.icons {
  display: flex;
}
</style>
